import React, {useRef, useState} from 'react';
import {useQueryClient} from "react-query";
import {useAuth0} from "@auth0/auth0-react";
import moment from "moment";
import {Tooltip} from '@material-ui/core';
import DataGrid from "../../../controls/DataGrid";

import { useAuditTrail} from "../../../services/audit";

const AuditTrailList = (_props) => {
  const {isAuthenticated} = useAuth0();

  const props = {
    ..._props
  }
  const [state, setState] = useState({
    canEdit: props.canEdit||false,
  });

  const dataGridRef = useRef();

  const queryClient = useQueryClient();
  const extraKeys = [props.objectUuid];

  const auditTrail = useAuditTrail({queryClient, extraKeys});
console.log(AuditTrailList);
  const getColumns = (props) => { 
    const baseColumn = {
      options: {
        cellStyle: { fontSize:14 },
      },
      editable: props.canEdit,
    };

    return [

/*
          {
            field: "fuelValue", 
            headerName: "Fuel Value", 
            width: 120,
            type: "numericColumn", 
            cellEditor: valueEditor, 
            cellRenderer: {
              component:"CurrencyValue", 
              params: {
                decimalScale: 2, 
                fixedDecimalScale: true,
              }
            },
            options: {
              cellStyle: {paddingLeft:"17px", paddingRight:"17px", boxShadow: "none", border: "0px", height: "calc(100% - 1px)"}
            }
          },
*/

      {
        ...baseColumn,
        headerName: "Date",
        field: "createdAt",
        width: 160,
        valueFormatter: (params)=> {
          return moment(params.value).utc().format("DD/MM/YYYY HH:mm");
        }
      },
      {
        ...baseColumn,
        headerName: "Action",
        field: "auditText",
        options: {
          ...baseColumn.options,
          flex: 1
        }
      },
      {
        ...baseColumn,
        headerName: "User",
        field: "userInfo",
        width: 80,
        cellRendererSelector: (props) => {return {
          component: "Wrapper", 
          params: {
            component: (
              <Tooltip arrow
                placement="top-start"
                title={`${props.value.firstName} ${props.value.lastName}`}
              >
                <div style={{position: "relative", lineHeight:"16px"}}>{props.value.initials}</div>
              </Tooltip>
            )
          }
        }}
      },
    ];
  };
  
  return (isAuthenticated &&
    <div style={{width: props.width?props.width:"100%", ...props.style}}>
      <DataGrid
        title="Audit Trail Management"
        ref={dataGridRef}
        columns={getColumns({canEdit: state.canEdit})}
        rows={auditTrail.data}
        height={props.height||"300px"}
        options={{
          singleClickEdit: true, 
          editType:'fullRow',
          onCellValueChanged: ()=>{}, //prevent default onCellValueChanged 
          defaultColDef: {
            editable: false,
            resizable: false,
          }
        }}
      />
    </div>
  );

}

export default AuditTrailList;
